import React from "react";
import { Card } from "antd";
import { BotonPrincipal } from "../componentes/btn";
import Slider from "react-slick";
import { ReactComponent as SeguridadIcon } from "../img/infraestructura/servicios/seguridad.svg";
import { ReactComponent as IotIcon } from "../img/infraestructura/servicios/iot.svg";
import { ReactComponent as ConectividadIcon } from "../img/infraestructura/servicios/conectividad.svg";
import { ReactComponent as CarePlusIcon } from "../img/infraestructura/servicios/carePlus.svg";
import { ReactComponent as devOps } from "../img/infraestructura/servicios/devOps.svg";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
export const CardServiciosInf = () => {
  const cardsData = [
    {
      icono: SeguridadIcon,
      lottie:
        "https://lottie.host/dcf789a9-825f-40e8-a59e-055ded11a03f/b5dUKIRiqB.lottie",
      title: "Seguridad",
      description:
        "Cámaras, radares, sensores y alarmas para detección inteligente de patentes, tráfico y peatones, mejorando la seguridad y control integral.",
    },
    {
      icono: IotIcon,
      lottie:
        "https://lottie.host/dcf789a9-825f-40e8-a59e-055ded11a03f/b5dUKIRiqB.lottie",
      title: "IoT",
      description:
        "Monitoreo remoto de dispositivos en casas, oficinas e industrias. Integración con plataformas web, aplicaciones móviles y sistemas inteligentes.",
    },
    {
      icono: ConectividadIcon,
      lottie:
        "https://lottie.host/dcf789a9-825f-40e8-a59e-055ded11a03f/b5dUKIRiqB.lottie",
      title: "Conectividad",
      description:
        "Administración de redes, cableado estructurado, mejora de redes inalámbricas, QoS, gestión avanzada de tráfico y ancho de banda eficiente.",
    },
    {
      icono: CarePlusIcon,
      lottie:
        "https://lottie.host/dcf789a9-825f-40e8-a59e-055ded11a03f/b5dUKIRiqB.lottie",
      title: "CarePlus",
      description:
        "Mantenimiento de equipos, actualización de software y hardware, cambio de PC y notebooks con asesoramiento técnico profesional.",
    },
    {
      icono: devOps,
      lottie:
        "https://lottie.host/dcf789a9-825f-40e8-a59e-055ded11a03f/b5dUKIRiqB.lottie",
      title: "DevOps",
      description:
        "Gestión de servidores, hosting, migración a cloud, copias de seguridad, cifrado de datos y conexiones VPN para máxima protección.",
    },
  ];

  const settings = {
    dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3, 
  slidesToScroll: 1,
      centerMode: true,
    centerPadding: "0px",
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerMode: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "20px",
        },
      },
    ],
  };

  return (
    <div className="contenedor-tarjetas" style={{margin:"0.5em"}}>
      <Slider {...settings}>
        {cardsData.map((data, index) => (
         <div
         key={index}
         style={{
           display: "flex", 
           justifyContent: "center", 
           alignItems: "center", 
           padding: "1em",

         }}
       >
            <Card
              title={
                <div style={{ position: "relative", height: "100px" }}>
                  <data.icono
                    className="icono-card"
                    style={{
                      position: "absolute",
                      top: "0.4em",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "5em",
                      zIndex: 2,
                    }}
                  />
                  <DotLottieReact
                    src={data.lottie}
                    loop
                    autoplay
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: "6em",
                      height: "6em",
                      borderRadius: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                    }}
                  />
                </div>
              }
              bordered={false}
              style={{
                position: "relative",
                overflow: "hidden",
                width: "300px",
                height: "auto",
                boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                borderRadius: "8px",
                justifyContent: "center",
                textAlign:"center"
              }}
              className="card-infr"
            >
           
              <h3 className="titulo-card">{data.title}</h3>
              <p className="card-description">{data.description}</p>
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "1em",
                }}
              >
                <BotonPrincipal
                  text="Más información"
                  colorFondo="#5583BA"
                  colorTexto="#ffffff"
                  onClick={() => {
                    const section = document.getElementById("contacto-footer");
                    section?.scrollIntoView({ behavior: "smooth" });
                  }}
                />
              </div>
            </Card>
          </div>
        ))}
      </Slider>
    </div>
  );
};
